<template>
  <v-container fluid class="inventory-page pa-4">
    <div class="inventory-top-card">
      <div class="inventory-header">
        <div class="inventory-title-wrap">
          <v-btn icon small class="mr-2" @click="$router.push({ path: '/inventory' })">
            <v-icon>mdi-home-outline</v-icon>
          </v-btn>

          <div>
            <div class="inventory-title">Inventory</div>
            <div class="inventory-subtitle">
              Manage purchases, purchase orders, and vendors.
            </div>
          </div>
        </div>

        <div class="inventory-actions" v-if="!$vuetify.breakpoint.xsOnly">
          <v-btn small rounded outlined to="/inventory/purchaseOrder/list">
            <v-icon left small>mdi-clipboard-list-outline</v-icon>
            Purchase Order
          </v-btn>

          <v-btn small rounded outlined to="/inventory/inboundDelivery/list">
            <v-icon left small>mdi-truck-check-outline</v-icon>
            Inbound Delivery
          </v-btn>

          <v-btn
            v-if="checkRightStatus(38)"
            small
            rounded
            color="primary"
            dark
            to="/inventory/purchase/list"
          >
            <v-icon left small>mdi-package-variant-closed-plus</v-icon>
            Purchase
          </v-btn>

          <v-btn small rounded outlined to="/inventory/vendor/list">
            <v-icon left small>mdi-storefront-outline</v-icon>
            Vendor
          </v-btn>
        </div>

        <v-menu offset-y v-else>
          <template v-slot:activator="{ on, attrs }">
            <v-btn small rounded color="primary" dark v-bind="attrs" v-on="on">
              {{ selectedLabel }}
              <v-icon right small>mdi-chevron-down</v-icon>
            </v-btn>
          </template>

          <v-list dense>
            <v-list-item
              @click="selectItem('Purchase Order', '/inventory/purchaseOrder/list')"
            >
              <v-list-item-icon>
                <v-icon small>mdi-clipboard-list-outline</v-icon>
              </v-list-item-icon>
              <v-list-item-title>Purchase Order</v-list-item-title>
            </v-list-item>

            <v-list-item
              v-if="checkRightStatus(38)"
              @click="selectItem('Purchase', '/inventory/purchase/list')"
            >
              <v-list-item-icon>
                <v-icon small>mdi-package-variant-closed-plus</v-icon>
              </v-list-item-icon>
              <v-list-item-title>Purchase</v-list-item-title>
            </v-list-item>

            <v-list-item
              v-if="checkRightStatus(38)"
              @click="selectItem('Inbound Delivery', '/inventory/inboundDelivery/list')"
            >
              <v-list-item-icon><v-icon small>mdi-truck-check-outline</v-icon></v-list-item-icon>
              <v-list-item-title>Inbound Delivery</v-list-item-title>
            </v-list-item>

            <v-list-item @click="selectItem('Vendor', '/inventory/vendor/list')">
              <v-list-item-icon>
                <v-icon small>mdi-storefront-outline</v-icon>
              </v-list-item-icon>
              <v-list-item-title>Vendor</v-list-item-title>
            </v-list-item>
          </v-list>
        </v-menu>
      </div>
    </div>

    <div class="inventory-route-content">
      <router-view />
    </div>
  </v-container>
</template>

<script>
import { mapGetters } from "vuex";
import RegisterStoreModule from "@/mixins/RegisterStoreModule";
import purchseService from "@/modules/Inventory/Purchase/store.js";

export default {
  name: "inventory",

  mixins: [RegisterStoreModule],

  data() {
    return {
      selectedLabel: "Inventory",
    };
  },

  computed: {
    ...mapGetters("global", ["checkRightStatus"]),
  },

  watch: {
    $route(to) {
      this.updateLabel(to.path);
    },
  },

  created() {
    this.registerStoreModule("purchase", purchseService);
    this.updateLabel(this.$route.path);
    document.title = "smplsale - Inventory";
  },

  methods: {
    selectItem(label, route) {
      this.selectedLabel = label;

      if (this.$route.path !== route) {
        this.$router.push(route);
      }
    },

    updateLabel(path) {
      if (path.includes("/inventory/warehouseExit")) {
        this.selectedLabel = "Warehouse Exit";
        return;
      }

      if (path.includes("/inventory/purchase/list")) {
        this.selectedLabel = "Purchase";
        return;
      }

      if (path.includes("/inventory/purchaseOrder/list")) {
        this.selectedLabel = "Purchase Order";
        return;
      }

      if (path.includes("/inventory/inboundDelivery")) {
        this.selectedLabel = "Inbound Delivery";
        return;
      }

      if (path.includes("/inventory/vendor/list")) {
        this.selectedLabel = "Vendor";
        return;
      }

      this.selectedLabel = "Inventory";
    },
  },
};
</script>

<style scoped>
.inventory-page {
  background: #f8fafc;
  min-height: 100%;
}

.inventory-top-card {
  border: 1px solid #e2e8f0;
  border-radius: 20px;
  background: #ffffff;
  overflow: hidden;
  margin-bottom: 16px;
}

.inventory-header {
  padding: 16px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  flex-wrap: wrap;
}

.inventory-title-wrap {
  display: flex;
  align-items: center;
}

.inventory-title {
  font-size: 22px;
  font-weight: 800;
  color: #0f172a;
}

.inventory-subtitle {
  font-size: 13px;
  color: #64748b;
  margin-top: 2px;
}

.inventory-actions {
  display: flex;
  align-items: center;
  gap: 10px;
  flex-wrap: wrap;
}

.inventory-route-content {
  padding: 0;
}

@media (max-width: 600px) {
  .inventory-page {
    padding: 10px !important;
  }
}
</style>
